/**
 * 竞价详情页路径
 */
export const AUCTION_DETAIL_PAGE_PATH = '/auction/detail'
